import { ChevronRight, Clock } from "lucide-react";
import { formatHM, isFromDal } from "@/lib/scheduleTime";

/**
 * TrainsetTicker — strip horizontal berisi maksimal 3 kereta upcoming
 * setelah entri yang sedang di-countdown di hero widget. Membantu
 * dispatcher melihat "antrian" tanpa harus scroll ke tabel.
 *
 * Props:
 *   items: Array of { row, at: Date }  (sudah di-sort ascending)
 *   now:   Date  (untuk hitung "in X min")
 */
export default function TrainsetTicker({ items, now }) {
  if (!items || items.length === 0) return null;

  return (
    <div
      className="mt-3 flex items-stretch gap-2 md:gap-3 overflow-x-auto"
      data-testid="trainset-ticker"
    >
      <div className="flex items-center gap-1.5 shrink-0 px-3 rounded-lg border border-[#243a52] bg-[#0a1929]/80 text-[10px] uppercase tracking-widest text-slate-400">
        <Clock className="h-3 w-3" />
        <span>Berikutnya</span>
      </div>
      {items.map((e, idx) => {
        const fromDal = isFromDal(e.row);
        const diffSec = Math.max(0, Math.floor((e.at - now) / 1000));
        const h = Math.floor(diffSec / 3600);
        const m = Math.floor((diffSec % 3600) / 60);
        const remain = h > 0 ? `${h}h ${m}m` : `${m}m`;
        const accent = fromDal
          ? "text-[#22d3ee] border-[#22d3ee]/40 bg-[#22d3ee]/5"
          : "text-white border-[#243a52] bg-[#0a1929]/60";
        return (
          <div
            key={`${e.row.id}-${idx}`}
            className={`flex-1 min-w-[180px] flex items-center gap-3 px-3 py-2 rounded-lg border ${accent}`}
            data-testid={`ticker-item-${idx}`}
          >
            <div className="flex items-center justify-center h-7 min-w-[26px] px-1.5 rounded-md bg-current/10 text-current text-xs font-bold">
              {idx + 2}
            </div>
            <div className="flex flex-col min-w-0 flex-1">
              <div className="flex items-baseline gap-2">
                <span className="font-mono text-base md:text-lg font-black tracking-tight leading-none">
                  {formatHM(e.at)}
                </span>
                <span className="text-[10px] uppercase tracking-widest opacity-70">
                  T-{remain}
                </span>
              </div>
              <div className="text-[11px] text-slate-400 truncate mt-0.5 flex items-center gap-1">
                <span className={fromDal ? "text-[#22d3ee]" : ""}>
                  {e.row.track_origin}
                </span>
                <ChevronRight className="h-3 w-3 shrink-0" />
                <span>{e.row.track_destination}</span>
              </div>
            </div>
            <div className="text-right">
              <div className="text-[9px] uppercase tracking-widest opacity-60">
                TS
              </div>
              <div className="font-mono font-black text-lg leading-none">
                {e.row.trainset_id}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
